import React, { useEffect, useRef } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import s from "./OtherCountriesDeportationList.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { getOtherCountriesDeportationDetails } from "../../redux/InformationSlice";
import { Link, useParams } from "react-router-dom";
import Navigation from "../../Components/Navigation/Navigation";
import ContactButtons from "../../Components/ContactButtons/ContactButtons";
import ScrollToTop from "../../Components/ScrollToTop/ScrollToTop";
import InCountry from "../../Components/InCountry/InCountry";
import CountriesBlueButtons from "../../Components/CountriesBlueButtons/CountriesBlueButtons";
import useWindowDimensions from "../../Components/WindowDimensions/WindowDimensions";
import MobileHeader from "../../Components/MobileHeader/MobileHeader";
import { useTranslation } from "react-i18next";
import { Seo } from "../../Seo";

const OtherCountriesDeportationList = () => {
  const data = useSelector(
    (state: RootState) => state.info.otherCountriesDeportationDetails,
  );

  const params = useParams();
  const dispatch: AppDispatch = useDispatch();
  const { width } = useWindowDimensions();
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(getOtherCountriesDeportationDetails(Number(params.id)));
  }, [params]);

  const footerRef = useRef<HTMLDivElement | null>(null);
  const scrollToFooter = () => {
    footerRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <Seo
        title="Страны с ограничениями на въезд для людей с ВИЧ"
        description="Где тест на ВИЧ обязателен для рабочей визы и ВНЖ, чтобы избежать депортации."
        url="https://www.vputi.org/otherCountries/deportation/1"
      />
      <div className={s.content}>
        {width > 1100 ? (
          <Header onContactsClick={scrollToFooter} />
        ) : (
          <MobileHeader onContactsClick={scrollToFooter} />
        )}
        <InCountry />
        <Navigation
          navigation={{
            name: "Главная / Законодательство других стран / Страны, которые депортируют иностранцев с ВИЧ-положительным статусом",
            path: "/otherCountries",
          }}
        />

        <ContactButtons />
        <div className={s.text}>
          <div className={s.title}>{data?.title_1}</div>
          <div
            className={s.body}
            dangerouslySetInnerHTML={{ __html: data?.body_1 ?? "" }}
          ></div>
          <div
            className={s.yellow_wrapper}
            dangerouslySetInnerHTML={{ __html: data?.body_2 ?? "" }}
          ></div>
          <div
            className={s.body1}
            dangerouslySetInnerHTML={{ __html: data?.body_3 ?? "" }}
          ></div>
          <div
            className={s.body3}
            dangerouslySetInnerHTML={{ __html: data?.body_4 ?? "" }}
          ></div>
        </div>
        <div className={s.title2}>
          {t("Где я могу пройти обследования на родине?")}
        </div>
        <CountriesBlueButtons />
      </div>
      <div ref={footerRef}>
        <Footer />
      </div>
      <ScrollToTop />
    </div>
  );
};

export default OtherCountriesDeportationList;
